<template>
    <div>
        <h5>All Existing Assessments</h5>
        <div v-if="checkUserPermission(UserPermissions.WRITE_ASSESSMENT)" class="card">
            <Button label="Create an assessment" @click="addAssessmentDialog = true" />
            <!-- add assessment dialog -->
            <assessment-form v-if="addAssessmentDialog" @hide-dialog="addAssessmentDialog = false" />
        </div>
        <div>
            <assessment-table />
        </div>
    </div>
</template>

<script setup>
import { ref, provide } from 'vue';
import AssessmentForm from '../components/AssessmentForm.vue';
import AssessmentTable from '../components/AssessmentTable.vue';

import { UserPermissions } from '@/products/modules/enums/permissions';
import useUserComposable from '@/composables/UserComposable';

import { useAssessmentStore } from '../store';
const assessmentStore = useAssessmentStore();

provide('assessmentStore', assessmentStore);

const { checkUserPermission } = useUserComposable();

const addAssessmentDialog = ref(false);
</script>
